const initialState = {
    anchor: 'left',
    parto: [],
    open: false,
    id: '',
    id_animal: '',
    id_fazenda: '',
    data: '',
    id_touro: '',
    tipo: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    nascido_morto: false,
    valido: true,
    fazenda: null
};

export function parto(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_PARTO':
            return {
                ...state,
                parto: action.parto
            };
        case 'PARTO_DETAIL':
            return {
                ...state,
                id: action.id,
                id_animal: action.id_animal,
                id_fazenda: action.id_fazenda,
                data: action.data,
                id_touro: action.id_touro,
                tipo: action.tipo,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                nascido_morto: action.nascido_morto,
                valido: action.valido,
                fazenda: action.fazenda
            };
        case "PARTO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
